import createReducer from './createReducer';
import * as actions from '../actions/actionTypes';
import { mergeAll } from 'ramda';

const crossSellOfferReducer = createReducer({}, {
  [actions.UPDATE_APRS]: (state, action) =>
    mergeAll([
      state,
      {
        aprs: action.aprs
      }
    ])
});

export default crossSellOfferReducer;
